import React, { Component } from "react";
import "component/list/FilterList/styles.scss";

class FitlerList extends Component {
  render() {
    if (this.props.list && this.props.list.size <= 1) return null;

    return (
      <div className="filter-list">
        {this.props.list &&
          this.props.list.map((item, key) => {
            return (
              <span
                className={`badge badge-${
                  this.props.selectedIndex === key ? "toggled" : "secondary"
                }`}
                key={key}
                onClick={() => {
                  if (!this.props.handleChange) return;
                  this.props.handleChange(key);
                }}
              >
                {item.get("name")}
              </span>
            );
          })}
        {!this.props.list &&
          [
            ...Array(this.props.skeletonCount ? this.props.skeletonCount : 5),
          ].map((item, key) => {
            return (
              <span
                className={`badge badge-secondary disabled`}
                key={key}
                onClick={() => {
                  if (!this.props.handleChange) return;
                  this.props.handleChange(key);
                }}
              >
                <span className="dummy">loading</span>
              </span>
            );
          })}
      </div>
    );
  }
}

export default FitlerList;
